import type { BaseHttpRequest, CancelablePromise } from '@/api';
import { ListResponseDto } from '@/api/response/list-response.dto';
import { CurrenciesDto } from '@/api/response/currencies/currencies.dto';
import { GetCurrenciesDto } from '@/api/request/currencies/get-currencies.dto';
import { CreateCurrenciesDto } from '@/api/request/currencies/create-currencies.dto';
import { UpdateCurrenciesDto } from '@/api/request/currencies/update-currencies.dto';

export class CurrenciesApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  public getCurrencyList(): CancelablePromise<Record<string, string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: `/currencies/currency-list`,
    });
  }

  public getProvidersCurrenciesList(dto: GetCurrenciesDto): CancelablePromise<ListResponseDto<CurrenciesDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: `/currencies/list`,
      query: dto,
    });
  }

  public createProviderCurrencies(dto: CreateCurrenciesDto): CancelablePromise<CurrenciesDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/currencies/create',
      mediaType: 'application/json',
      body: dto,
    });
  }

  public updateProviderCurrencies(id: number, dto: UpdateCurrenciesDto): CancelablePromise<CurrenciesDto> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/currencies/update/{id}',
      path: { id },
      body: dto,
      mediaType: 'application/json',
    });
  }

  public deleteProviderCurrencies(id: number): CancelablePromise<CurrenciesDto> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/currencies/delete/{id}',
      path: { id },
    });
  }
}
